/*
 * @Author: yangxu
 * @Description:
 * @Date: 2023-05-24 17:45:29
 * @LastEditTime: 2023-07-18 19:30:41
 * @FilePath: /js_zuhe-2023_src/src/utils/request.js
 */
import axios from 'axios';

// create an axios instance
const service = axios.create({
	baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
	withCredentials: true, // send cookies when cross-domain requests
	timeout: 50000, // request timeout
});

// request interceptor
service.interceptors.request.use(
	(config) => {
		// do something before request is sent

		// config.url = window?.httpToHttps.editHost(
		// 	`${config.url}${
		// 		config.url.match(/\?/gi) ? '&' : '?'
		// 	}=_${new Date().getTime()}`
		// );
		return config;
	},
	(error) => {
		// do something with request error
		console.log(error); // for debug
		return Promise.reject(error);
	}
);

// response interceptor
service.interceptors.response.use(
	/**
	 * If you want to get http information such as headers or status
	 * Please return  response => response
	 */

	/**
	 * Determine the request status by custom code
	 * Here is just an example
	 * You can also judge the status by HTTP Status Code
	 */
	(response) => {
		return response.data;
	},
	(error) => {
		console.log('err' + error); // for debug
		return Promise.reject(error);
	}
);

export default service;
